module.exports = __webpack_public_path__ + "img/stagedoor.5659dc4c.jpg";